import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';

function Footer() {
  const [contactData, setContactData] = useState(null);
// console.log(contactData);
const [visitorCount, setVisitorCount] = useState(null);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`
          // " https://manifriendstraders.com/customer_api/content.php"
        );
        const { body } = response.data;
        setContactData(body.contact);
        setVisitorCount(body.visitor_count)
      } catch (error) {
        console.error("Error fetching the contact data", error);
      }
    };

    fetchContactData();
  }, []);

  // Fallback content if data is not loaded
  if (!contactData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <footer id="footer" className="footer dark-background">
        <div className="container1">
          <div className="row gy-3">
            <div className="col-lg-2 col-md-6 d-flex">
              <i className="bi bi-geo-alt icon"></i>
              <div className="address">
                <h4>Address</h4>
                <p className='contactfooter'>{contactData.address}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex">
              <i className="bi bi-telephone icon"></i>
              <div>
                <h4>Contact</h4>
                <p className='contactfooter'>
                  <strong >Phone:</strong> <span>{contactData.phonenumber}</span><br/><br/>
                  <strong>Email:</strong> <span>{contactData.email}</span><br/><br/>
                  <strong>WhatsApp:</strong> <span>{contactData.whatsapp_number}</span>
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex">
              {/* <i className="bi bi-clock icon"></i> */}
              <div>
                {/* <h4>Opening Hours</h4>
                <p className='contactfooter'>
                  
                  <span>{contactData.timing}</span><br/><br/>
                  
                </p> */}
                <h3>Visitors Count: {visitorCount.visitor_count}</h3>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 d-flex">
              <i className="bi bi-telephone icon"></i>
              <div>
                <h4>Quick Links</h4>
                <p className='footer-quicklink'>
                <Link to= "/shippingpolicy"> <strong style={{ color: "lightgreen" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Shipping & Delivery</span><br/><br/></Link>
                  <Link to= "/terms">  <strong style={{ color: "lightgreen" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Terms & Conditions</span><br/><br/> </Link>
                 <Link to= "/privacy"> <strong style={{ color: "lightgreen" }}><i className="bi bi-arrow-right"></i></strong> <span className='footlinks'>Privacy Policy</span> </Link>
                </p>
              </div>
            </div>

            <div className="col-lg-2 col-md-6">
              <h4>Follow Us</h4>
              <div className="social-links d-flex">
                
                <Link to="/" className="facebook"><i className="bi bi-facebook"></i></Link>
                <Link to="/" className="instagram"><i className="bi bi-instagram"></i></Link>
                <Link to="/" className="linkedin"><i className="bi bi-youtube"></i></Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="rules">
          <p className='rules1'>
            Please Note: The honorable Supreme Court of India has banned sales of firecrackers from 2018. We obey the order and we don't permit online
            purchase of crackers. For your convenience, we show our products on the website. We request you to add your products to the Quick
            Purchase and submit the required crackers through the enquiry button. We will contact you within 24 hrs and confirm the order
            through WhatsApp or phone call. Please add and submit your enquiries and enjoy your Diwali with VMK Traders.
          </p>
          
        </div>
       
      </footer>
      <div className="container12 text-center mt-4">
          <p><span>Copyright © {new Date().getFullYear()}</span> <strong className="px-1 sitename">VMK Traders .</strong> <span>All Rights Reserved.</span> Developed by <Link to="https://aatheshsoft.com/" style={{ color: "white" }}> Aathesh Soft Solutions</Link></p>
          {/* <p style={{fontSize:"14px"}}>This site is forwarded to "Magilchi Pyro Park , Sivakasi"</p> */}
        </div>
    </div>
  );
}

export default Footer;
